import { DIMENSIONS, EXPERTS, JOB } from '../content'
import { anim, stagger } from '../motion'
import { Avatar, BeamBands, Box, COLORS, Check, Shape } from '../primitives'

// Schritte: 0 Frage · 1 Expert:innen · 2 Ideal- und Übergangsbereiche
const TRACK = { x: 204, w: 286 }

export default function SceneRequirements() {
  return (
    <>
      <Box
        x={40}
        y={40}
        w={330}
        h={124}
        className='sty-card sty-pad'
        style={anim({ at: [0.01, 0.12] })}
      >
        <div className='sty-eyebrow'>Neue Stelle</div>
        <div className='sty-h4'>{JOB}</div>
        <div className='sty-row sty-mt-3'>
          <Avatar initials='M' color='blue' size={28} />
          <span className='sty-muted'>Mara · Recruiting</span>
        </div>
      </Box>

      <Box
        x={40}
        y={196}
        w={330}
        h={150}
        className='sty-question'
        style={anim({ at: [0.06, 0.18], out: [0.29, 0.35], y: 30 })}
      >
        <Shape
          kind='tri'
          color='yellow'
          size={30}
          rotate={-12}
          className='sty-question__shape'
        />
        Was muss die neue Person wirklich können?
      </Box>

      {EXPERTS.map((e, i) => (
        <Box
          key={e.initials}
          x={40}
          y={196 + i * 116}
          w={330}
          h={100}
          className='sty-card sty-pad sty-row'
          style={anim({ at: stagger(0.35, 0.03, 0.07, i), x: -40, y: 0 })}
        >
          <Avatar initials={e.initials} color={e.color} size={44} />
          <div className='sty-grow'>
            <div className='sty-strong'>{e.name}</div>
            <div className='sty-muted'>{e.role}</div>
          </div>
          <div style={anim({ at: stagger(0.44, 0.02, 0.04, i), s: 0.3, y: 0 })}>
            <Check />
          </div>
        </Box>
      ))}

      <Box
        x={400}
        y={40}
        w={520}
        h={560}
        className='sty-card'
        style={anim({ at: [0.03, 0.16], x: 40, y: 0 })}
      >
        <div className='sty-pad'>
          <div className='sty-eyebrow'>Anforderungsprofil</div>
          <div className='sty-h4'>{JOB}</div>
        </div>

        {DIMENSIONS.map((d, row) => {
          const top = 120 + row * 80
          return (
            <div
              key={d.name}
              className='sty-abs'
              style={{ left: 0, top, width: 520 }}
            >
              <div className='sty-dim-label' style={{ left: 24, top: 0 }}>
                {d.name}
              </div>
              <div
                className='sty-track'
                style={{ left: TRACK.x, top: 4, width: TRACK.w }}
              >
                <BeamBands
                  ideal={d.ideal}
                  trans={d.trans}
                  at={stagger(0.66, 0.02, 0.08, row)}
                />
              </div>
              {d.experts.map((v, e) => (
                <div
                  key={e}
                  className='sty-abs'
                  style={{ left: TRACK.x + (v / 100) * TRACK.w - 7, top: 3 }}
                >
                  <div
                    className='sty-dot'
                    style={{
                      background: COLORS[EXPERTS[e].color],
                      ...anim({
                        at: stagger(0.38 + e * 0.03, 0.01, 0.05, row),
                        s: 0.2,
                        y: -20
                      })
                    }}
                  />
                </div>
              ))}
            </div>
          )
        })}

        <div
          className='sty-abs sty-row'
          style={{ left: 24, top: 500, ...anim({ at: [0.74, 0.82], y: 10 }) }}
        >
          <span
            className='sty-legend-swatch'
            style={{ background: 'rgb(167 247 231)' }}
          />
          <span className='sty-muted'>Idealbereich</span>
          <span
            className='sty-legend-swatch sty-ml-4'
            style={{ background: 'rgb(253 218 148)' }}
          />
          <span className='sty-muted'>Übergangsbereich</span>
          <span className='sty-badge sty-ml-4'>DIN 33430</span>
        </div>
      </Box>
    </>
  )
}
